const POSITIVE_TOKENS = [
  '1',
  'true',
  'active',
  'available',
  'enabled',
  'live',
  'ok',
  'online',
  'open',
  'ongoing',
  'running',
  'started'
]

const NEGATIVE_TOKENS = [
  '0',
  'false',
  'closed',
  'disabled',
  'ended',
  'expired',
  'finished',
  'inactive',
  'locked',
  'not_available',
  'not_started',
  'offline',
  'pending',
  'unavailable',
  'upcoming'
]

const UNAVAILABLE_ACTIVITY_TOKENS = [
  'demo',
  'fallback',
  'fallback_used',
  'fallback-used',
  'fallback used',
  'mock',
  'mock_fallback',
  'mock-fallback',
  'mock fallback',
  'placeholder',
  'sample',
  'static',
  'static_fallback',
  'static-fallback',
  'static fallback',
  'stub',
  'unimplemented',
  'not_implemented',
  'not implemented',
  'need_login',
  'dataunavailable',
  'data_unavailable',
  'data-unavailable',
  'data unavailable',
  'read_only',
  'readonly',
  'read only',
  'read-only',
  'read_only_action',
  'read-only-action',
  'read only action',
  'read_failure',
  'read-failure',
  'read failure',
  'read_unavailable',
  'read-unavailable',
  'read unavailable',
  'read_failed',
  'read-failed',
  'read failed',
  'route_unavailable',
  'route-unavailable',
  'route unavailable',
  'technical_marker',
  'technical-marker',
  'technical marker',
  'technical_error',
  'technical-error',
  'technical error',
  'technical_exception',
  'technical-exception',
  'technical exception',
  'backend_failure',
  'backend-failure',
  'backend failure',
  'false_proof',
  'false-proof',
  'false proof',
  'proxy_read_failure',
  'proxy-read-failure',
  'proxy read failure',
  'write_blocked',
  'writeblocked',
  'write blocked',
  'write-blocked',
  'backend_blocked',
  'backendblocked',
  'backend blocked',
  'backend-blocked',
  'action_blocked',
  'actionblocked',
  'action blocked',
  'action-blocked',
  'blocked',
  'not_connected',
  'not-connected',
  'not connected'
]

const ACTIVE_MARKER_TOKENS = [
  '1',
  'true',
  'active',
  'enabled',
  'on',
  'yes'
]

function token(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function compactToken(value) {
  return token(value).replace(/[\s-]+/g, '_')
}

function isPositive(value) {
  if (value === true || value === 1) return true
  return POSITIVE_TOKENS.includes(compactToken(value))
}

function isNegative(value) {
  if (value === false || value === 0) return true
  return NEGATIVE_TOKENS.includes(compactToken(value))
}

function isUnavailableActivityToken(value) {
  const normalized = token(value)
  return !!normalized && (
    UNAVAILABLE_ACTIVITY_TOKENS.includes(normalized) ||
    normalized.includes('demo') ||
    normalized.includes('fallback') ||
    normalized.includes('mock') ||
    normalized.includes('placeholder') ||
    normalized.includes('sample') ||
    normalized.includes('static') ||
    normalized.includes('dataunavailable') ||
    normalized.includes('data_unavailable') ||
    normalized.includes('data-unavailable') ||
    normalized.includes('data unavailable') ||
    normalized.includes('read_only') ||
    normalized.includes('readonly') ||
    normalized.includes('read only') ||
    normalized.includes('read-only') ||
    normalized.includes('read_only_action') ||
    normalized.includes('read-only-action') ||
    normalized.includes('read only action') ||
    normalized.includes('read_failure') ||
    normalized.includes('read-failure') ||
    normalized.includes('read failure') ||
    normalized.includes('read_unavailable') ||
    normalized.includes('read-unavailable') ||
    normalized.includes('read unavailable') ||
    normalized.includes('read_failed') ||
    normalized.includes('read-failed') ||
    normalized.includes('read failed') ||
    normalized.includes('route_unavailable') ||
    normalized.includes('route-unavailable') ||
    normalized.includes('route unavailable') ||
    normalized.includes('technical_marker') ||
    normalized.includes('technical-marker') ||
    normalized.includes('technical marker') ||
    normalized.includes('technicalmarker') ||
    normalized.includes('technical_error') ||
    normalized.includes('technical-error') ||
    normalized.includes('technical error') ||
    normalized.includes('technical_exception') ||
    normalized.includes('technical-exception') ||
    normalized.includes('technical exception') ||
    normalized.includes('backend_failure') ||
    normalized.includes('backend-failure') ||
    normalized.includes('backend failure') ||
    normalized.includes('backendfailure') ||
    normalized.includes('false_proof') ||
    normalized.includes('false-proof') ||
    normalized.includes('false proof') ||
    normalized.includes('proxy_read_failure') ||
    normalized.includes('proxy-read-failure') ||
    normalized.includes('proxy read failure') ||
    normalized.includes('unimplemented') ||
    normalized.includes('not_implemented') ||
    normalized.includes('not implemented') ||
    normalized.includes('need_login') ||
    normalized.includes('write_blocked') ||
    normalized.includes('writeblocked') ||
    normalized.includes('write blocked') ||
    normalized.includes('write-blocked') ||
    normalized.includes('backend_blocked') ||
    normalized.includes('backendblocked') ||
    normalized.includes('backend blocked') ||
    normalized.includes('backend-blocked') ||
    normalized.includes('action_blocked') ||
    normalized.includes('actionblocked') ||
    normalized.includes('action blocked') ||
    normalized.includes('action-blocked') ||
    normalized.includes('not_connected') ||
    normalized.includes('not-connected') ||
    normalized.includes('not connected') ||
    normalized === 'blocked'
  )
}

function isUnavailableActivityText(value) {
  const normalized = token(value)
  return !!normalized && (
    isUnavailableActivityToken(value) ||
    normalized.includes('not implemented') ||
    normalized.includes('not connected') ||
    normalized.includes('not_connected') ||
    normalized.includes('not-connected') ||
    normalized.includes('read unavailable') ||
    normalized.includes('read_unavailable') ||
    normalized.includes('read-unavailable') ||
    normalized.includes('route unavailable') ||
    normalized.includes('route_unavailable') ||
    normalized.includes('route-unavailable') ||
    normalized.includes('technical marker') ||
    normalized.includes('technical_marker') ||
    normalized.includes('technical-marker') ||
    normalized.includes('technicalmarker') ||
    normalized.includes('technical error') ||
    normalized.includes('technical_error') ||
    normalized.includes('technical-error') ||
    normalized.includes('technical exception') ||
    normalized.includes('technical_exception') ||
    normalized.includes('technical-exception') ||
    normalized.includes('backend failure') ||
    normalized.includes('backend_failure') ||
    normalized.includes('backend-failure') ||
    normalized.includes('backendfailure') ||
    normalized.includes('false proof') ||
    normalized.includes('false_proof') ||
    normalized.includes('false-proof') ||
    normalized.includes('read_only') ||
    normalized.includes('readonly') ||
    normalized.includes('read-only') ||
    normalized.includes('read only') ||
    normalized.includes('write blocked') ||
    normalized.includes('write-blocked') ||
    normalized.includes('fake success') ||
    normalized.includes('no-write') ||
    normalized.includes('未接入') ||
    normalized.includes('只读') ||
    normalized.includes('未执行') ||
    normalized.includes('阻止假成功') ||
    normalized.includes('阻止假发奖')
  )
}

function isActiveUnavailableMarker(value) {
  if (value === true || value === 1) return true
  return ACTIVE_MARKER_TOKENS.includes(compactToken(value))
}

function hasProofValue(value) {
  if (value === true || value === 1) return true
  if (value === false || value === 0) return false
  const normalized = token(value)
  return !!normalized && !isNegative(normalized) && !isUnavailableActivityToken(normalized)
}

function hasNonEmptyCollection(value) {
  return Array.isArray(value) && value.length > 0
}

function hasReadOnlyQueryData(activity) {
  const readOnlyQuery = activity.readOnlyQuery || activity.read_only_query || activity.readProof || activity.read_proof
  if (!hasProofValue(readOnlyQuery)) return false
  return [
    activity.list,
    activity.rows,
    activity.records,
    activity.items,
    activity.dataList,
    activity.data_list,
    activity.contentList,
    activity.content_list
  ].some(hasNonEmptyCollection)
}

function hasStaticNavigationEntry(activity) {
  return typeof activity.route === 'string' && activity.route.trim().startsWith('/')
}

export function normalizeActivityVisibility(activity, options = {}) {
  if (!activity || typeof activity !== 'object') {
    return { visible: false, reason: 'empty' }
  }

  const guardedUnavailableMarkers = [
    activity.mock,
    activity.mockMode,
    activity.mock_mode,
    activity.mockFallback,
    activity.mock_fallback,
    activity.stub,
    activity.fallback,
    activity.fallbackUsed,
    activity.fallback_used,
    activity.dataUnavailable,
    activity.data_unavailable,
    activity.unimplemented,
    activity.notImplemented,
    activity.not_implemented,
    activity.notSupported,
    activity.not_supported,
    activity.unsupported,
    activity.writeBlocked,
    activity.write_blocked,
    activity.backendBlocked,
    activity.backend_blocked,
    activity.actionBlocked,
    activity.action_blocked,
    activity.readOnlyAction,
    activity.read_only_action,
    activity.readFailure,
    activity.read_failure,
    activity.readUnavailable,
    activity.read_unavailable,
    activity.readFailed,
    activity.read_failed,
    activity.routeUnavailable,
    activity.route_unavailable,
    activity.technicalMarker,
    activity.technical_marker,
    activity.technicalError,
    activity.technical_error,
    activity.technicalException,
    activity.technical_exception,
    activity.backendFailure,
    activity.backend_failure,
    activity.falseProof,
    activity.false_proof,
    activity.proxyReadFailure,
    activity.proxy_read_failure,
    activity.blocked,
    activity.readOnly,
    activity.read_only,
    activity.readOnlyMode,
    activity.read_only_mode
  ]

  const unavailableMarkers = [
    activity.status,
    activity.state,
    activity.result,
    activity.code,
    activity.errorCode,
    activity.fallbackSource,
    activity.fallback_source,
    activity.msg,
    activity.message,
    activity.reason,
    activity.desc,
    activity.description
  ]

  if (
    guardedUnavailableMarkers.some(value => isActiveUnavailableMarker(value) || isUnavailableActivityToken(value)) ||
    unavailableMarkers.some(value => value === true || isUnavailableActivityText(value))
  ) {
    return { visible: false, reason: 'unavailable_marker' }
  }

  const hardBlockers = [
    activity.visible,
    activity.show,
    activity.active,
    activity.isActive,
    activity.enabled,
    activity.enable
  ]

  if (hardBlockers.some(value => isNegative(value))) {
    return { visible: false, reason: 'flag_blocked' }
  }

  if ([activity.disabled, activity.expired, activity.isDisabled, activity.isExpired].some(isPositive)) {
    return { visible: false, reason: 'unavailable' }
  }

  if ([activity.status, activity.state, activity.activityStatus].some(isNegative)) {
    return { visible: false, reason: 'status_blocked' }
  }

  if (
    [activity.visible, activity.show, activity.active, activity.isActive, activity.enabled, activity.enable]
      .some(isPositive) ||
    [activity.status, activity.state, activity.activityStatus].some(isPositive)
  ) {
    return { visible: true, reason: 'explicit' }
  }

  const proofSignals = [
    activity.serverVisibilityProof,
    activity.server_visibility_proof,
    activity.visibilityProof,
    activity.visibility_proof,
    activity.activityProof,
    activity.activity_proof,
    activity.serverReadProof,
    activity.server_read_proof,
    activity.readProof,
    activity.read_proof,
    activity.backendProof,
    activity.backend_proof,
    activity.serverProof,
    activity.server_proof,
    activity.proof
  ]

  if (options.defaultVisible && proofSignals.some(hasProofValue)) {
    return { visible: true, reason: 'proof' }
  }

  if (options.defaultVisible && hasReadOnlyQueryData(activity)) {
    return { visible: true, reason: 'read_only_query' }
  }

  if (options.defaultVisible && hasStaticNavigationEntry(activity)) {
    return { visible: true, reason: 'static_navigation' }
  }

  // fail-open:已通过全部硬阻断检查(无 unavailable 标记 / 无 negative flag / 无显式 disabled)。
  // 对显式要求默认可见(defaultVisible)的展示型活动入口,缺信号时默认「可见」而非隐藏 ——
  // 避免后端活动字段命名/信号与前端不完全对齐就整页活动消失(P0-4)。点击进入仍各自校验登录/可领。
  if (options.defaultVisible) {
    return { visible: true, reason: 'default_visible' }
  }

  return { visible: false, reason: 'missing_signal' }
}

export function isActivityVisible(activity, options = {}) {
  return normalizeActivityVisibility(activity, options).visible
}
